import { buildDemoStudentsForClass } from "./buildDemoStudents";
import { buildDemoStudentClassStatus } from "./buildDemoStudentClassStatus";

/** Mesmo id nas rotas Academics/student/:id/* (gráficos). */
export const DEMO_STUDENT_WAYBEE_USER_ID = 1;

/**
 * Verifica se o RA pertence à turma demo (perfil / ocorrências / horários).
 */
export function isDemoStudentId(studentId) {
  const students = buildDemoStudentsForClass("DEMO-T1");
  return students.some(x => String(x.ra) === String(studentId));
}

/**
 * Perfil completo (GET ClassDiaryV1/student/:ra/profile).
 * Campos alinhados ao retorno do waybee-api (getStudentProfile).
 */
export function buildDemoStudentProfile(studentId) {
  const students = buildDemoStudentsForClass("DEMO-T1");
  const s = students.find(x => String(x.ra) === String(studentId));
  if (!s) {
    return null;
  }

  return {
    id: s.id,
    ra: s.ra,
    name: s.name,
    photo: s.photo,
    socialName: null,
    nickname: s.name.split(" ")[0] || null,
    surname: null,
    birthday: "2010-03-15T00:00:00.000Z",
    birthState: "SP",
    birthStateName: "São Paulo",
    birthCity: "São Paulo",
    tel: "(11) 3333-0101",
    tel2: "",
    email: `aluno.${s.ra}@demonstracao.waybee.local`,
    obs:
      "Participação ativa nas atividades de demonstração. Este texto aparece em «Mais observações sobre o aluno» (demo offline).",
    contacts: {
      resp: [
        {
          name: "Responsável Pedagógico Demo",
          relationship: "Mãe · Responsável acadêmico",
          tel1: "(11) 98888-1001",
          tel2: "(11) 3222-1002",
          email: "responsavel.pedagogico@demonstracao.waybee.local"
        },
        {
          name: "Responsável Financeiro Demo",
          relationship: "Pai · Responsável financeiro",
          tel1: "(11) 97777-2002",
          tel2: "",
          email: "responsavel.financeiro@demonstracao.waybee.local"
        }
      ],
      respTransport: [
        {
          name: "Transporte Demo",
          relationship: "Responsável de transporte",
          tel1: "(11) 96666-3003",
          tel2: "",
          email: "transporte@demonstracao.waybee.local"
        }
      ]
    },
    /** Legado; Boletim/Gráficos usam RA (não dependem mais deste id). */
    waybeeUserId: DEMO_STUDENT_WAYBEE_USER_ID,
    /** Aula em andamento + próxima (protótipo perfil — funcionários). */
    classStatus: buildDemoStudentClassStatus(studentId)
  };
}
